import 'lazysizes'
import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import setupNavigation from './components/setupNavigation'
import loadComponents from './global/loadComponents'

gsap.registerPlugin(ScrollToPlugin)

setupNavigation()

window.addEventListener('load', () => {
  loadComponents(document.body)
})
